// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"ribbon_ribbon__39KOE","warningPopover":"ribbon_warningPopover__cUjH9"};